import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { setCookies } from '../hooks/useCookies';
import { ADMIN_AUTH_URL } from './apiConstants';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
};
const signup = 'signup';
export const signUp = createAsyncThunk('api/signup', async (data) => {
  const body = {
    name: data.name,
    email: data.email,
    password: data.password,
  };
  return axios
    .post(`${ADMIN_AUTH_URL}/${signup}`, body, { headers })
    .then((response) => {
      if (response.status === 200 && response.data.success) {
        setCookies('Token', response.data.data.user.auth_token);
        setCookies('refreshToken', response.data.data.user.refresh_token);
        setCookies('USERID', response.data.data.user.user_id);
        setCookies('USERNAME', response.data.data.user.name);
        setCookies('USEREMAIL', response.data.data.user.email);
        setCookies('THEME', 'false');
      }
      return response.data;
    })
    .catch((e) => e);
});

const registrationSlice = createSlice({
  name: 'api',
  initialState: {
    loading: false,
    signupData: {},
    error: '',
  },
  extraReducers: {
    [signUp.pending]: (state) => {
      /* eslint-disable no-param-reassign */
      state.loading = true;
    },
    [signUp.fulfilled]: (state, action) => {
      state.loading = false;
      state.signupData = action.payload;
      if (action.payload && action.payload.success) {
        toast.success('Admin registration successful');
      }
    },
    [signUp.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      toast.error('Error');
    },
  },
});

export default registrationSlice.reducer;
